


















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import NewTranslation from '@/components/i18n/NewTranslation.vue';

@Component({
  components: {
    NewTranslation,
  },
})
export default class TransactionExternalReferenceOverlay extends Vue {
  @Prop({ type: Object, required: false })
  public transaction!: any | null;

  @Emit()
  public close(): void {}
}
